<template>
  <section class="hp-wrap content d-flex flex-column flex-column-fluid">
    <div class="d-flex flex-column-fluid" v-if="!getErrorsStatus">
      <div class="container-fluid hp-container">
        <div class="row mb-10">
          <div class="col-12">

            <!-- Page heading -->
            <div class="hp-heading">
              <h2 class="hp-heading__title">Schedule an Appointment</h2>
            </div>

            <!-- Search bar -->
            <div class="hp-search">
              <i class="flaticon2-search-1 hp-search__icon"></i>
              <input
                type="text"
                class="hp-search__input"
                placeholder="Find Service"
                v-model="search"
                @keyup.enter="SearchData"
              />
            </div>

            <!-- Section label -->
            <div class="hp-section-label">
              <i
                v-if="Groupservices.length !== 0"
                class="fa fa-arrow-left hp-back-icon"
                @click="gobackGroupservice"
              ></i>
              {{ Groupservices.length !== 0 ? 'Services in Group' : 'Please select a service/group' }}
            </div>

            <!-- Loading -->
            <div class="hp-spinner" v-if="dataLoading">
              <loading-spinner></loading-spinner>
              <p>Please wait…</p>
            </div>

            <!-- Top-level services -->
            <div
              class="row"
              v-if="Groupservices.length === 0 && !dataLoading && !flag"
            >
              <div
                class="col-12 col-md-6 col-lg-4 mb-3"
                v-for="(service, index) in filteredServices"
                :key="index + 10"
                v-show="
                  filteredServices.length > 0 &&
                  !dataLoading &&
                  ((service.feature_type === 'Group' && service.object_detail.service_count > 0) ||
                    service.feature_type === 'Service')
                "
              >
                <v-service-card
                  :url="url"
                  :service="service"
                  v-on:getGropedService="getGropedService"
                />
              </div>

              <div class="col-12 text-center hp-empty" v-show="filteredServices.length <= 0 && !dataLoading">
                <v-no-record></v-no-record>
              </div>
            </div>

            <!-- Group services -->
            <div
              class="row"
              v-if="Groupservices.length > 0 && !dataLoading"
            >
              <div
                class="col-12 col-md-6 col-lg-4 mb-3"
                v-for="(serv, i) in Groupservices"
                :key="1 + i"
              >
                <v-group-service-card :url="url" :service="serv" />
              </div>
            </div>

            <!-- Empty (after group expand) -->
            <div class="col-12 text-center hp-empty" v-show="Groupservices.length <= 0 && !dataLoading && flag">
              <v-no-record></v-no-record>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- 404 -->
    <div v-if="getErrorsStatus">
      <div class="d-flex flex-column flex-root text-center">
        <div class="mt-40">
          <div class="px-10 px-md-30 py-10 py-md-0 d-flex flex-column justify-content-md-center">
            <h1 class="error-title color-prim text-transparent" style="font-weight:bold;font-size:50px;">404</h1>
            <p class="display-4 font-weight-boldest color-prim mb-12">How did you get here</p>
            <p class="font-size-h1 font-weight-boldest text-dark-75">Sorry we can't seem to find the page you're looking for.</p>
            <p class="font-size-h4 line-height-md">There may be a misspelling in the URL entered<br />or the page you are looking for may no longer exist.</p>
          </div>
        </div>
      </div>
    </div>

    <v-copy-right-footer></v-copy-right-footer>
  </section>
</template>

<script>
import vTitle from "@/components/frontend/title";
import vServiceCard from "@/components/frontend/servicecard";
import vGroupServiceCard from "@/components/frontend/groupservicecard";
import vNoRecord from "@/components/frontend/norecord";
import { mapGetters } from "vuex";
import {
  FETCH_F_SERVICES,
  FETCH_F_NOTE,
  FRONTEND_GET_GROUP,
  FRONTEND_SERVICE_SEARCH
} from "@/core/services/store/actions.type";
import loadingSpinner from "@/components/frontend/spinner.vue";
import vCopyRightFooter from "@/components/frontend/copyrightfooter";

export default {
  components: {
    vTitle,
    vServiceCard,
    vNoRecord,
    loadingSpinner,
    vGroupServiceCard,
    vCopyRightFooter
  },
  data() {
    return {
      searchInput: "",
      loading: false,
      dataLoading: false,
      theValue: "",
      services: [],
      url: "",
      Groupservices: [],
      search: "",
      flag: false
    };
  },
  mounted() {
    this.$emit("startclock", 1);
    this.fetchServices();
    if (
      this.getServiceProviderData.fav_icon != null ||
      this.getServiceProviderData.fav_icon != ""
    ) {
      document.querySelector("link[rel='icon']").href = this.getServiceProviderData.fav_icon;
    }
  },
  computed: {
    filteredServices() {
      let tempServices = this.services;
      if (this.searchInput !== "" && this.searchInput) {
        tempServices = tempServices.filter(item =>
          item.name.toUpperCase().includes(this.searchInput.toUpperCase())
        );
      }
      if (this.search !== "" && this.search) {
        tempServices = tempServices.filter(item =>
          item.object_detail.name.toUpperCase().includes(this.search.toUpperCase())
        );
      }
      return tempServices;
    },
    ...mapGetters([
      "getfServices",
      "getClientSlug",
      "getServiceProviderData",
      "getErrorsStatus"
    ])
  },
  methods: {
    getGropedService(val) {
      this.dataLoading = true;
      this.flag = true;
      this.$store
        .dispatch(FRONTEND_GET_GROUP, { id: val.id, slug: val.client_slug })
        .then(data => {
          this.dataLoading = false;
          this.Groupservices = data.data;
        })
        .catch(() => { this.dataLoading = false; });
    },
    SearchData() {
      this.dataLoading = true;
      this.flag = true;
      this.$store
        .dispatch(FRONTEND_SERVICE_SEARCH, {
          search_text: this.search,
          slug: this.$route.params.client_slug
        })
        .then(data => {
          this.dataLoading = false;
          this.Groupservices = data.data;
        })
        .catch(() => { this.dataLoading = false; });
    },
    gobackGroupservice() {
      this.flag = false;
      this.Groupservices = [];
      this.fetchServices();
    },
    fetchServices() {
      var slug = this.$route.params.client_slug;
      this.$store.dispatch(FETCH_F_NOTE, slug);
      this.dataLoading = true;
      this.flag = false;
      this.$store
        .dispatch(FETCH_F_SERVICES, slug)
        .then(data => {
          if (data.type === "featured") {
            this.services = data.data;
          } else {
            this.Groupservices = data.data;
          }
          this.url = data.url;
          this.dataLoading = false;
        })
        .catch(() => { this.dataLoading = false; });
    }
  }
};
</script>

<style lang="scss">
/* All styles wrapped in .hp-wrap so they don't bleed to other pages */
$teal:      #5bb8b1;
$teal-dark: #2c7d76;
$teal-bg:   #e4f3f0;
$dark:      #1a1a2e;
$font:      'Segoe UI', system-ui, sans-serif;

.hp-wrap {
  background: $teal-bg !important;
  min-height: 100vh;
  font-family: $font;
}

.hp-container {
  padding-top: 20px;
  padding-bottom: 80px;

  @media (min-width: 768px)  { padding-top: 28px; }
  @media (min-width: 1024px) { padding-top: 36px; }
}

/* ── Heading ── */
.hp-heading {
  margin-bottom: 16px;

  @media (min-width: 768px) { margin-bottom: 20px; }

  &__title {
    font-size: 22px;
    font-weight: 700;
    color: $teal-dark;
    margin: 0;

    @media (min-width: 768px)  { font-size: 26px; }
    @media (min-width: 1024px) { font-size: 30px; }
  }
}

/* ── Search bar ── */
.hp-search {
  display: flex;
  align-items: center;
  background: #fff;
  border: 2px solid $teal;
  border-radius: 10px;
  padding: 0 16px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(91,184,177,0.10);

  @media (min-width: 768px) { margin-bottom: 24px; border-radius: 12px; }

  &__icon {
    color: $teal;
    font-size: 18px;
    flex-shrink: 0;
    margin-right: 10px;
    line-height: 1;
  }

  &__input {
    flex: 1;
    height: 50px;
    border: none;
    outline: none;
    font-size: 15px;
    font-family: $font;
    color: $dark;
    background: transparent;

    @media (min-width: 768px) { height: 56px; font-size: 16px; }

    &::placeholder { color: #9aaeb0; }
  }
}

/* ── Section label ── */
.hp-section-label {
  font-size: 13px;
  font-weight: 600;
  color: #5a7875;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 10px;

  @media (min-width: 768px) { font-size: 14px; margin-bottom: 18px; }
}

.hp-back-icon {
  cursor: pointer;
  width: 30px; height: 30px;
  border-radius: 50%;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: $teal-dark;
  border: 1.5px solid #c5dede;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;

  &:hover { background: $teal; color: #fff; border-color: $teal; }
}

/* ── Loading / empty ── */
.hp-spinner {
  text-align: center;
  padding: 40px 0;
  color: #5a7875;
  font-size: 14px;
}

.hp-empty { padding: 40px 0; }
</style>
